import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Path, Defs, Stop, LinearGradient } from 'react-native-svg';

const HexagonSettings = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 58}
          height={props.height ?? 52}
          viewBox="0 0 58 52"
          fill="none"
          {...props}
        >
          <Path
            d="M45.1901 3.53382C44.3076 1.98314 42.1147 0.726562 40.3229 0.726562H17.3771C15.5853 0.726562 13.4191 1.98314 12.5098 3.53382L1.0369 23.3985C0.154368 24.9492 0.154368 27.4623 1.0369 29.013L12.5098 48.8777C13.3923 50.4284 15.5853 51.6849 17.3771 51.6849H40.3229C42.1147 51.6849 44.2809 50.4284 45.1901 48.8777L56.663 29.013C57.5456 27.4623 57.5456 24.9492 56.663 23.3985L45.1901 3.53382Z"
            fill="url(#paint0_linear_2992_6470)"
          />
          <Path
            d="M44.0873 6.4868C43.3155 5.12609 41.3974 4.02344 39.8303 4.02344H19.7612C18.194 4.02344 16.2994 5.12609 15.5041 6.4868L5.46954 23.918C4.69765 25.2788 4.69765 27.4841 5.46954 28.8448L15.5041 46.276C16.276 47.6367 18.194 48.7394 19.7612 48.7394H39.8303C41.3974 48.7394 43.2921 47.6367 44.0873 46.276L54.1219 28.8448C54.8938 27.4841 54.8938 25.2788 54.1219 23.918L44.0873 6.4868Z"
            fill="white"
          />
          <Path
            d="M42.6383 8.50277C41.9446 7.27996 40.221 6.28906 38.8126 6.28906H20.7775C19.3692 6.28906 17.6666 7.27996 16.9519 8.50277L7.93431 24.1674C7.24065 25.3902 7.24065 27.372 7.93431 28.5948L16.9519 44.2594C17.6455 45.4822 19.3692 46.4731 20.7775 46.4731H38.8126C40.221 46.4731 41.9236 45.4822 42.6383 44.2594L51.6558 28.5948C52.3495 27.372 52.3495 25.3902 51.6558 24.1674L42.6383 8.50277Z"
            fill="#FCEABB"
          />
          <Path
            d="M36.9496 23.4284C35.1396 23.4284 34.3996 22.1484 35.2996 20.5784C35.8196 19.6684 35.5096 18.5084 34.5996 17.9884L32.8696 16.9984C32.0796 16.5284 31.0596 16.8084 30.5896 17.5984L30.4796 17.7884C29.5796 19.3584 28.0996 19.3584 27.1896 17.7884L27.0796 17.5984C26.6296 16.8084 25.6096 16.5284 24.8196 16.9984L23.0896 17.9884C22.1796 18.5084 21.8696 19.6784 22.3896 20.5884C23.2996 22.1484 22.5596 23.4284 20.7496 23.4284C19.7096 23.4284 18.8496 24.2784 18.8496 25.3284V27.0884C18.8496 28.1284 19.6996 28.9884 20.7496 28.9884C22.5596 28.9884 23.2996 30.2684 22.3896 31.8384C21.8696 32.7484 22.1796 33.9084 23.0896 34.4284L24.8196 35.4184C25.6096 35.8884 26.6296 35.6084 27.0996 34.8184L27.2096 34.6284C28.1096 33.0584 29.5896 33.0584 30.4996 34.6284L30.6096 34.8184C31.0796 35.6084 32.0996 35.8884 32.8896 35.4184L34.6196 34.4284C35.5296 33.9084 35.8396 32.7384 35.3196 31.8384C34.4096 30.2684 35.1496 28.9884 36.9596 28.9884C37.9996 28.9884 38.8596 28.1384 38.8596 27.0884V25.3284C38.8496 24.2884 37.9996 23.4284 36.9496 23.4284ZM28.8496 29.4584C27.0596 29.4584 25.5996 27.9984 25.5996 26.2084C25.5996 24.4184 27.0596 22.9584 28.8496 22.9584C30.6396 22.9584 32.0996 24.4184 32.0996 26.2084C32.0996 27.9984 30.6396 29.4584 28.8496 29.4584Z"
            fill="#E89823"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_2992_6470"
              x1="28.85"
              y1="0.726562"
              x2="28.85"
              y2="51.6849"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stopColor="#FF9900" />
            </LinearGradient>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { HexagonSettings };
